import type { FormAnswer, FormQuestion, TicketForm } from "@msc/shared";

export type Answers = Record<string, FormAnswer>;

const CHOICE_TYPES = new Set(["cm", "cs", "cd"]);
const TEXT_TYPES = new Set(["ts", "tl"]);

/** Was das Cockpit bedienen kann: Häkchen, Radio, Dropdown, kurzer und langer Text. Alles andere nur lesen. */
export function isEditableType(type: string): boolean {
  return CHOICE_TYPES.has(type) || TEXT_TYPES.has(type);
}

export function isChoiceType(type: string): boolean {
  return CHOICE_TYPES.has(type);
}

export function initialAnswers(form: TicketForm): Answers {
  const out: Answers = {};
  for (const q of form.questions) {
    const existing = form.answers[q.id];
    if (isChoiceType(q.type)) out[q.id] = { choices: existing?.choices ?? [] };
    else if (TEXT_TYPES.has(q.type)) out[q.id] = { text: existing?.text ?? "" };
    else if (existing) out[q.id] = existing;
  }
  return out;
}

export function toggleChoice(answers: Answers, questionId: string, choiceId: string, multiple: boolean): Answers {
  const current = answers[questionId]?.choices ?? [];
  const next = multiple
    ? current.includes(choiceId) ? current.filter((c) => c !== choiceId) : [...current, choiceId]
    : [choiceId];
  return { ...answers, [questionId]: { choices: next } };
}

export function setText(answers: Answers, questionId: string, text: string): Answers {
  return { ...answers, [questionId]: { text } };
}

/** Pflichtfragen, die noch leer sind — die serverseitige Prüfung der Forms-API bleibt das letzte Wort. */
export function missingRequired(form: TicketForm, answers: Answers): FormQuestion[] {
  return form.questions.filter((q) => {
    if (!q.required) return false;
    const a = answers[q.id];
    if (isChoiceType(q.type)) return (a?.choices?.length ?? 0) === 0;
    if (TEXT_TYPES.has(q.type)) return !(a?.text ?? "").trim();
    return false;
  });
}
